export const COLORS = {
  white: '#ffffff',
  black: '#000000',
  darkGray: '#898989',
  darkestGray: '#5b5b5b',
  gray: '#b7b7b7',
  lightGray: '#d5d5d5',
  lightestGray: '#f4f4f4',
  red: '#e85c4a',
  lightestRed: '#ffefed',
  orange: '#ff6937',
  lightestOrange: '#fcf6e9',
  yellow: '#ffc043',
  lightYellow: '#ffdd9b',
  lightGreen: '#0ccd78',
  green: '#09a460',
  darkGreen: '#09a460',
  aqua: '#54dca0',
  lightAqua: '#87e6bc',
  lightestAqua: '#baf1d9',
  blue: '#276ef1',
  lightBlue: '#8ef4ff',
  lightestBlue: '#e8f7fe',
  purple: '#a214ab',
  lightPurple: '#e4a3e8',
  lightestPurple: '#f4e2f9',
  body: '#ffffff',
  normal: '#121212',
  secondary: '#5b5b5b',
  border: '#ececec',
  primary: '#121212',
  lightPrimary: '#d5d5d5',
  lightestPrimary: '#e5e5e5',
  darkPrimary: '#898989',
  darkestPrimary: '#5b5b5b',
  darkestRed: '#761104',
  darkRed: '#c62510',
  lightRed: '#eea9a0',
  darkestOrange: '#7c1f00',
  darkOrange: '#d93600',
  lightOrange: '#fab199',
  darkestYellow: '#815600',
  darkYellow: '#e19600',
  lightestYellow: '#ffffff',
  darkestGreen: '#004527',
  lightestGreen: '#37de95',
  darkestAqua: '#0d6d42',
  darkAqua: '#1db873',
  darkestBlue: '#002770',
  darkBlue: '#0346c1',
  darkestPurple: '#46024a',
  darkPurple: '#76097d',
} as const;
